import React from 'react';
import PropTypes from 'prop-types';
import BlankImage from '../../../assets/images/operation_blank_logo.png';
import CustomIMG from './styles';

const OperationLogo = ({ src, name, size }) => <CustomIMG src={src || BlankImage} alt={name} size={size} />;

OperationLogo.defaultProps = {
  size: 'normal',
};

OperationLogo.propTypes = {
  src: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['normal', 'medium']),
};

export default OperationLogo;
